import { Tooltip } from 'antd'
import React from 'react'

const BulkDownloadIcon = () => {
  return (
    <Tooltip title="Bulk Upload">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_19630_1801)">
<rect x="2" y="1" width="38" height="38" rx="5" fill="#FBFAFF"/>
<rect x="2.5" y="1.5" width="37" height="37" rx="4.5" stroke="#E3DEFF"/>
<path d="M27.1572 26.2404C27.1572 26.4654 26.9738 26.6478 26.7498 26.6478H11.2593C11.0353 26.6478 10.8519 26.4654 10.8519 26.2404V13.7596C10.8519 13.5346 11.0353 13.3522 11.2593 13.3522H16.2929C16.4003 13.3522 16.5049 13.3957 16.5808 13.4716L18.8735 15.7637C19.3004 16.1906 19.8671 16.4258 20.4708 16.4258H20.9643L22.7894 14.5737H20.4708C20.3625 14.5737 20.2597 14.5311 20.1828 14.4542L17.8911 12.1621C17.4642 11.7352 16.8966 11.5 16.2929 11.5H11.2593C10.0139 11.5 9 12.5141 9 13.7596V26.2404C9 27.4869 10.0139 28.5 11.2593 28.5H26.7498C27.9952 28.5 29.0091 27.4869 29.0091 26.2404V23.1297H27.1572V26.2404Z" fill="#3249D7"/>
<path d="M27.1571 16.3943V21.2497H29.0091V16.3943H33L28.1062 11.5L23.2598 16.3943H27.1571Z" fill="#3249D7"/>
</g>
<defs>
<filter id="filter0_d_19630_1801" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19630_1801"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19630_1801" result="shape"/>
</filter>
</defs>
</svg>

    </Tooltip>
  )
}

export default BulkDownloadIcon